import {
  KnockFeedProvider,
  KnockProvider,
  NotificationFeedPopover,
  UnseenBadge,
} from "@knocklabs/react";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import { IoMdNotificationsOutline } from "react-icons/io";

import { Tooltip, TooltipContent, TooltipTrigger } from "@sorcery/ui";

import { env } from "~/env";
import { useUser } from "~/providers/UserProvider";
import { NotificationFeedEnum } from "~/types/notification";
import { deckPath, userPath } from "~/utils/paths";

export const InAppNotifications = () => {
  const [isVisible, setIsVisible] = useState(false);

  const notifButtonRef = useRef(null);
  const { user } = useUser();
  const router = useRouter();

  return (
    <div className="group/notifs px-1">
      <KnockProvider
        apiKey={env.NEXT_PUBLIC_KNOCK_PUBLIC_KEY}
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        userId={user!.id.toString()}
        // biome-ignore lint/style/noNonNullAssertion: <explanation>
        userToken={user!.knock}
      >
        <KnockFeedProvider feedId={"f090d8c8-6818-4e3d-b73d-4e7d9abfe2da"}>
          <span ref={notifButtonRef} className="relative">
            <Tooltip>
              <TooltipTrigger onClick={() => setIsVisible(!isVisible)}>
                <IoMdNotificationsOutline
                  size={17}
                  className={
                    "mt-2 transition duration-150 ease-in-out group-hover/notifs:opacity-60"
                  }
                />
                <span className="absolute -right-2.5 -top-3.5">
                  <UnseenBadge badgeCountType="unseen" />
                </span>
              </TooltipTrigger>
              <TooltipContent>
                <p>Notifications</p>
              </TooltipContent>
            </Tooltip>
          </span>

          <NotificationFeedPopover
            buttonRef={notifButtonRef}
            isVisible={isVisible}
            onClose={() => {
              setIsVisible(false);
            }}
            onNotificationClick={(item) => {
              if ((item.source.key as NotificationFeedEnum) === NotificationFeedEnum.COMMENTS) {
                if ((item.data as { deck_id: string })?.deck_id) {
                  void router.push(
                    `${deckPath((item.data as { deck_id: string }).deck_id)}?tab=comments`,
                  );
                }
              }
              if ((item.source.key as NotificationFeedEnum) === NotificationFeedEnum.LIKES) {
                if ((item.data as { deck_id: string })?.deck_id) {
                  void router.push(deckPath((item.data as { deck_id: string }).deck_id));
                }
              }
              if ((item.source.key as NotificationFeedEnum) === NotificationFeedEnum.FOLLOWS) {
                if (item.actors?.[0]?.id) {
                  void router.push(userPath(item.actors[0].id));
                }
                setIsVisible(false);
              }
            }}
            closeOnClickOutside={true}
          />
        </KnockFeedProvider>
      </KnockProvider>
    </div>
  );
};
